import { StyleSheet } from '@react-pdf/renderer';

import { COLORS } from '@/shared/constants/colors';

export const styles = StyleSheet.create({
  page: {
    padding: '74px 76px',
    fontSize: 14,
    lineHeight: 1.25,
    backgroundColor: COLORS.white,
    color: COLORS.systemDark300,
  },
  pageTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 24,
  },
  section: {
    marginBottom: 24,
    break: false,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 24,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 6,
    minHeight: 14,
    gap: 16,
  },
  label: {
    maxWidth: 220,
    color: COLORS.systemDark200,
  },
  value: {
    flex: 1,
    fontWeight: 'normal',
  },
  itemTitle: {
    fontSize: 12,
    marginBottom: 8,
    fontWeight: 'bold',
  },
  groupTitleContainer: {
    gap: 4,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  groupTitle: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  badge: {
    color: COLORS.systemDark200,
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '16px',
  },
});
